import { Link, useLocation } from 'react-router-dom'

import { clsx } from '@it-incubator/ui-kit'

import s from './toc-node.module.scss'

import { NodeData } from './toc-node.types'

interface NodeProps {
  currentHeading?: string
  data: NodeData
  depth: number
}

export function TocNode({ currentHeading, data, depth }: NodeProps) {
  const location = useLocation()

  if (!data) {
    return null
  }

  switch (data.type) {
    case 'list':
      return (
        <ul className={s.list}>
          {data.children.map((child, index) => (
            <TocNode currentHeading={currentHeading} data={child} depth={depth} key={index} />
          ))}
        </ul>
      )
    case 'listItem':
      return (
        <li className={s.listItem}>
          {data.children.map((child, index) => (
            <TocNode currentHeading={currentHeading} data={child} depth={depth + 1} key={index} />
          ))}
        </li>
      )
    case 'paragraph':
      return (
        <>
          {data.children.map((child, index) => (
            <TocNode currentHeading={currentHeading} data={child} depth={depth} key={index} />
          ))}
        </>
      )
    case 'link':
      return (
        <Link
          className={clsx(s.link, data.url === `#${currentHeading}` && s.active)}
          data-depth={depth}
          replace
          title={data.title ?? undefined}
          to={{
            hash: data.url,
            search: location.search,
          }}
        >
          {data.children.map((child, index) => (
            <TocNode currentHeading={currentHeading} data={child} depth={depth} key={index} />
          ))}
        </Link>
      )
    case 'text':
      return <>{data.value}</>
    default:
      return null
  }
}
